import React from "react";

const GreyGridBackground: React.FC = () => {
  return (
    <div className="absolute inset-0 pointer-events-none z-[-1]">
      {/* Grid lines */}
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: `
            repeating-linear-gradient(
              to right,
              rgba(200,200,200,0.3),
              rgba(200,200,200,0.3) 1px,
              transparent 1px,
              transparent 100px
            ),
            repeating-linear-gradient(
              to bottom,
              rgba(200,200,200,0.3),
              rgba(200,200,200,0.3) 1px,
              transparent 1px,
              transparent 100px
            )
          `,
          backgroundRepeat: "repeat",
        }}
      />

      {/* Fade at bottom */}
      <div
        className="absolute bottom-0 left-0 w-full h-32"
        style={{
          background: "linear-gradient(to bottom, rgba(255,255,255,0), white 100%)",
        }}
      />

      {/* Fade on right (starts earlier) */}
      <div
        className="absolute top-0 right-0 h-full"
        style={{
          width: "35%", // increased width to start fade earlier
          background: "linear-gradient(to right, rgba(255,255,255,0), white 100%)",
        }}
      />
      {/* Fade on top-left corner (diagonal fade) */}
      <div
        className="absolute top-0 left-0 w-40" // width of the fade
        style={{
          height: "70%", // increase vertical coverage
          background: "linear-gradient(to bottom right, white 0%, rgba(255,255,255,0) 100%)",
        }}
      />


    </div>


  );
};

export default GreyGridBackground;
